import { useEffect, useState, useRef } from 'react';

/**
 * Hook to listen for messages from the iframe
 * @param {string} messageType - The type of message to listen for (optional)
 * @param {object} options - Additional options
 * @param {boolean} options.debug - Whether to log debug information
 * @returns {any} The latest message value for the specified type
 */
export const useIframeMessageListener = (messageType, options = {}) => {
  const { debug = false } = options;
  const [messageValue, setMessageValue] = useState(null);
  const receivedCount = useRef(0);

  useEffect(() => {
    const handleIframeMessage = (event) => {
      const data = event.data;
      console.log(`[useIframeMessageListener] Received message from iframe:`, data);

      if (debug) {
        console.log(`[useIframeMessageListener] Received message event:`, data);
      }


      // If no messageType is specified, or the message type matches the requested type
      if (data.type === messageType) {
        receivedCount.current += 1;
        if (true) {
          console.log(`[useIframeMessageListener] Matched type "${messageType}", count: ${receivedCount.current}`, data.value);
        }
        setMessageValue(data.value);
      }
    };

    if (debug) {
      console.log(`[useIframeMessageListener] Setting up listener for message type: "${messageType}"`);
    }

    window.addEventListener('message', handleIframeMessage);

    return () => {
      if (debug) {
        console.log(`[useIframeMessageListener] Removing listener for message type: "${messageType}"`);
      }
      window.removeEventListener('message', handleIframeMessage);
    };
  }, [messageType, debug]);

  return messageValue;
};